import {FaMoon, FaSun} from "react-icons/fa";

export default function ProjectBar({ projects, selectedKey, onChangeProject, modeKey, onToggleMode }) {
    const isDark = modeKey === "dark";

    return (
        <div className={[
            "sticky top-0 z-[100] w-full px-4 py-2 relative min-h-[56px]",
            isDark ? "bg-[#063a6c] text-white/80" : "bg-[#031B34] text-white/70",
        ] .join(" ")}>
            <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-3 mt-1">
                <label htmlFor="select-project" className="text-sm whitespace-nowrap">Selecione um projeto</label>
                <select
                    id="select-project"
                    className={[
                        "w-56 rounded-md px-3 py-2 text-sm outline-none border",
                        "focus:ring-2 focus:ring-[#1588f3]/60",
                        isDark
                            ? "bg-white/10 text-white border-white/15"
                            : "bg-white text-[#031B34] border-zinc-300",
                    ].join(" ")}
                    value={selectedKey}
                    onChange={(e) => onChangeProject(e.target.value)}
                >
                    {projects.map((p) => (
                        <option key={p.key} value={p.key}
                                // className="text-white bg-[#1f4e7b]"
                                className={[ isDark ? "text-white bg-[#1f4e7b]" : "bg-white text-black"].join(" ")}
                        >
                            {p.label}
                        </option>
                    ))}
                </select>
            </div>
            <div className="absolute right-4 top-1/2 -translate-y-1/2">
                <button
                    className={[
                        "h-10 w-10 rounded-full grid place-items-center transition",
                        isDark ? "hover:bg-white/10" : "hover:bg-black/10",
                        "active:scale-95",
                    ].join(" ")}
                    onClick={onToggleMode}
                    aria-label="Alternar tema"
                    title="Alternar tema"
                >
                    { isDark ? <FaMoon size={18} /> : <FaSun size={18} /> }
                </button>
            </div>
        </div>
    );
}